






























import store from '../store'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component

export default class Album extends Vue {
  if_more: boolean = true // 是否有下一页
  audios: any = []
  album: any = null // 专辑信息
  opened: boolean = false
  async mounted() {
    await this.initPage().catch(e => {
      console.error('error: ', e)
      this.$router.push('/albumErr')
    })
    // 设置分享时显示的图片和标题
    await store.setupShare({imgUrl: this.album.pic_url + '?x-oss-process=image/resize,w_750', title: this.album.title})
  }
  async initPage() {
    await this.getAlbumInfo()
  }
  async getAlbumInfo() {
    let res = await this.$axios.get(`/api/mobile/audios/resource2/albumDetail`, {
      params: {
        id: this.$route.params.albumId,
        limit: 10,
        offset: this.audios.length,
        includes: 'description,audios',
        from: 'qr'
      }
    })
    this.if_more = res.data.audios.length >= 10
    this.album = res.data
    this.audios = [...this.audios, ...res.data.audios.filter(c => ['律动', '故事', '歌曲', '童谣'].includes(c.audio_track))]
  }
  async infiniteLoad() {
    if (!this.if_more) return
    await this.getAlbumInfo()
  }
  summary(text, long = 48) {
    return text.length > long ? `${text.substr(0, long)}...` : text
  }
}
